import useTranslation from 'next-translate/useTranslation';

import { DisclosureButton } from '@headlessui/react';
import clsx from 'clsx';

import { useSearchBoxContext } from '@/utils/hooks/context/searchBox/useSearchBoxContext';

import { DefaultAvatar as Avatar } from '@/components/base/Avatar';
import Icon from '@/components/base/Icon';
import Radio from '@/components/base/Radio';
import type { GroupsFormattedType } from '@/components/layouts/LayoutPlatform/components/Header/components/ManageProfiles/Popover/GroupsTab';

type GroupItemProps = {
    group: GroupsFormattedType;
    open: boolean;
};

export function GroupItem({ group, open }: GroupItemProps) {
    const { t } = useTranslation();
    const { dispatch } = useSearchBoxContext<GroupsFormattedType>();
    return (
        <div className="relative">
            <DisclosureButton
                data-testid={`button-toggle-group-${group.id}`}
                className="absolute -left-4 top-1/2 mr-2 flex -translate-y-1/2 items-center text-xs">
                <Icon
                    icon="chevron-bottom"
                    className={clsx(
                        'text-icoGray-400 transition-transform dark:text-icoDarkMode-wolf',
                        { 'rotate-180': open }
                    )}
                />
            </DisclosureButton>
            <label className="flex cursor-pointer items-center justify-between gap-3">
                <span className="flex-1 overflow-hidden text-left focus:ring-0 focus:ring-offset-0">
                    <span className="flex items-center gap-2 overflow-hidden">
                        <Avatar
                            size="sm"
                            radius="rounded-md"
                            url={group.image}
                            fallback={group.name.substring(0, 2)}
                        />
                        <span className="flex flex-1 flex-col gap-0.5 overflow-hidden">
                            <span className="truncate text-xs text-icoBlack dark:text-white">
                                {group.name}
                            </span>
                            <span className="truncate font-GMedium text-xxs text-icoGray-500 dark:text-icoDarkMode-wolf">
                                {t('commons:social_profiles_count', {
                                    count: group.social_profiles.length
                                })}
                            </span>
                        </span>
                    </span>
                </span>
                <span>
                    <Radio
                        size="sm"
                        data-testid={`group-${group.id}`}
                        id={group.id.toString()}
                        checked={group.selected}
                        onChange={() => {
                            dispatch({
                                type: 'SELECT_ONLY_ONE',
                                payload: group
                            });
                        }}
                    />
                </span>
            </label>
        </div>
    );
}
